import { render, staticRenderFns } from "./cardBagList.vue?vue&type=template&id=d023503e&scoped=true&"
import script from "./cardBagList.vue?vue&type=script&lang=js&"
export * from "./cardBagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d023503e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d023503e')) {
      api.createRecord('d023503e', component.options)
    } else {
      api.reload('d023503e', component.options)
    }
    module.hot.accept("./cardBagList.vue?vue&type=template&id=d023503e&scoped=true&", function () {
      api.rerender('d023503e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Homelive/components/cardBagList.vue"
export default component.exports